<ion-header [style.--background]="customerColor">
  <ion-toolbar [style.--background]="customerColor">
    <ion-title id="title"> {{ titleName }} </ion-title>

    <ion-buttons slot="end">
      <ion-button fill="outine" size="small" (click)="backBtn()">
        <ion-icon id="menu-color" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-alert
      [isOpen]="mostrarAlerta"
      header="{{'CONFIRM' | translate}}"
      message="{{'SURE' | translate}}"
      [buttons]="botoesAlerta"
      (didDismiss)="mostrarAlerta = false"
    ></ion-alert>
  </ion-toolbar>
</ion-header>
